var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-container"},[_c('h5',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('reports.dashboards.teamsEvaluations'))+"\n    ")]),_c('apexchart',{attrs:{"type":"bar","series":_vm.countBySection,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }